import React from "react";
import {
  Cell,
  Pie,
  PieChart as RechartPie,
  ResponsiveContainer,
  Tooltip,
} from "recharts";
interface PieChartProps {
  data: any;
}
const COLORS = ["#1677ff", "#22c55e", "#f59e0b", "#ef4444", "#8b5cf6"];

const PieChart: React.FC<PieChartProps> = ({ data }) => {
  return (
    <ResponsiveContainer minHeight={300}>
      <RechartPie>
        {/* <Pie
					nameKey="location"
					data={data}
					fill="#8884d8"
					dataKey="count"
					label
				>
					{data.map((entry: any, index: any) => (
						<Cell key={`cell-${index}`} fill={'#525252'} />
					))}
				</Pie> */}
        <Pie
          nameKey="location"
          label={(entry) => entry.location + " (" + entry.count + ")"}
          data={data}
          fill="#8884d8"
          dataKey="count"
        >
          {data.map((entry: any, index: any) => (
            <Cell fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie>
        <Tooltip />
      </RechartPie>
    </ResponsiveContainer>
  );
};
export default PieChart;
